module.exports = __webpack_public_path__ + "img/ua.4ba8d70a.svg";